import { clamp } from 'lodash';
import * as React from 'react'


export default class PaulSearch extends React.Component {

    list
    getter

    state = {
        filteredlist:[],
        filter:'',
        focused:false,
        index:0,
    }


    componentDidMount(){
        //todo
        // this.props.setSelectedEvent.listen((item) => {
        //     this.setState({selected:item})
        // })
        this.myRef = React.createRef();
        this.setState({filteredlist:[...this.props.list]})
    }

    componentDidUpdate(prevProps){
        if(prevProps.list != this.props.list){
            this.setState({
                filteredlist:this.props.list.filter(item => {
                    return item[this.props.getter].includes(this.state.filter)
                })
            })
        }
    }

    render(){
        var showLabel = this.props.selected != null && this.state.focused == false
        return <div style={{width:"200px",display:'flex',flexDirection:"column", position:"relative"}}>
            {/* <label style={{position:"absolute",left:"20px",top:"-13px",background:"white"}}>{this.props.label}</label> */}
            <label className={'paulsearch ' + (this.state.focused || this.props.selected != null ? 'focused' : '')} style={{
                display:showLabel ? "" : "", position:"absolute",background:"white",pointerEvents:"none",
                color:this.props.disableSearch? "#777" :"auto",
            }}>{this.props.label}</label>
            <input disabled={this.props.disableSearch} style={{color:this.props.disableSearch? "#777" :"auto",border:'1px solid black', borderRadius:"50px",padding:"10px"}} 
            value={this.state.focused ?  this.state.filter : this.props.selected?.[this.props.getter] ?? ''} 
            onTouchEnd={(e) => {
                e.target.focus()
                console.log("touchend")
            }}
            onChange={(e) => {
                var searchstring = e.target.value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
                this.setState({
                    index:0,
                    filter:e.target.value,
                    filteredlist:this.props.list.filter(item => {
                        var valstocheck = [item.description.toLowerCase()]
                        valstocheck.push(...item.synonyms.map(obj => obj.synonym.toLowerCase()))
                        for(var val of valstocheck){
                            val = val.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
                            if(val.includes(searchstring)){
                                return true
                            }
                        }
                        return false
                        // return item[this.props.getter].toLowerCase().includes(e.target.value.toLowerCase())
                    })
                })
            }}
            onKeyDown={(e) => {
                var newindex = this.state.index
                if(e.key == "ArrowDown"){
                    newindex = this.state.index + 1
                }else if(e.key == "ArrowUp"){
                    newindex = this.state.index - 1
                }else if(e.key == "Enter"){
                    this.props.valueChange(this.state.filteredlist[this.state.index])
                    setTimeout(() => this.setState({ focused: false }), 200);
                }

                newindex = clamp(newindex,0,this.myRef.current.children.length - 1)
                this.setState({index:newindex})
                this.myRef.current.children[newindex].scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    // inline:"center"
                })
                
            }}
            onFocus={() => {
                this.setState({focused:true})
            }}
            onBlur={() => {
                setTimeout(() => this.setState({ focused: false }), 200);
            }}
            ></input>
            <ul ref={this.myRef} style={{
                position:"absolute",
                top:"100%",
                padding: 0,
                margin: 0,
                // boxSizing: 'border-box',
                listStyle:"none",
                maxHeight: '300px',
                overflowY: 'auto',
                border: '1px solid #ccc',
                backgroundColor: 'white',
                zIndex:500,
                display:this.state.focused ? '' : 'none'
            }}>
                {this.state.filteredlist.map((item,i) => {
                    return <li style={{
                            padding: '8px',
                            cursor: 'pointer',
                            borderBottom: '1px solid #f0f0f0',
                            background:i == this.state.index ? 'lightblue' :'white',
                        }}
                        key={i} 
                        onTouchEnd={() => {
                            this.props.valueChange(item)
                            this.setState({index:i})
                            setTimeout(() => this.setState({ focused: false }), 200);
                        }}
                        onClick={(e) => {
                            // this.setState({selected:item})
                            this.props.valueChange(item)
                            this.setState({index:i})
                        }} 
                    value={item.id}>{item[this.props.getter]}</li>
                })}
            </ul>
        </div>
    }
}